import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/zillehuma/zysoftec/source/app/Components/aboutus/section.tsx");
